import React from "react";

const Testimonials = () => (
  <section className="quote-section ls s-py-60 s-py-md-90 s-pt-xl-120 s-pb-xl-110">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div
            className="owl-carousel testimonials-owl"
            data-loop="true"
            data-margin="0"
            data-nav="true"
            data-dots="true"
            data-center="false"
            data-items="1"
            data-autoplay="true"
            data-responsive-xs="1"
            data-responsive-sm="1"
            data-responsive-md="1"
            data-responsive-lg="1"
          >
            <div className="quote-item testimonial">
              <h2 className="special-heading underline text-center">
                What people say about JMTY
              </h2>
              <blockquote>
                <p>
                  I was unable to get a job after graduating with my master’s
                  degree in Accounting. I reached out to JMTY and Kemi who is an
                  accounting and finance expert worked with me. We had three
                  consultation sessions where she helped recraft my resume,
                  prepare me for interviews and improve my communication skills.
                  Eventually, I received two offers from companies i had applied
                  to previously, but was unsuccessful.
                </p>
                <footer>
                  <cite>Lucy</cite>
                </footer>
              </blockquote>
              <div className="count">
                <p></p>
              </div>
            </div>
            <div className="quote-item testimonial">
              <h2 className="special-heading underline text-center">
                What people say about JMTY
              </h2>
              <blockquote>
                <p>
                  I moved to the U.S. for my bachelor’s and then Master’s degree
                  in Public Health. In my final semester of my Master’s program,
                  I started to feel the pressure of landing a job before
                  graduation. After applying to multiple positions, without any
                  callback or response, I decided to reach out to JMTY. JMTY
                  revamped my resume and within two weeks of applying with my
                  new resume, I got a callback which then became a job and the
                  best part-my employer was willing to sponsor my H-1B visa.
                </p>
                <footer>
                  <cite>Aisha</cite>
                </footer>
              </blockquote>
              <div className="count">
                <p></p>
              </div>
            </div>
            <div className="quote-item testimonial">
              <h2 className="special-heading underline text-center">
                What people say about JMTY
              </h2>
              <blockquote>
                <p>
                  It’s really nice what you do with JMTY. I wish something like
                  this was available when I initially moved to the US.
                </p>
                <footer>
                  <cite>Omobolaji</cite>
                </footer>
              </blockquote>
              <div className="count" style={{display: "none"}}>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;
